(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const featuresSection = document.querySelector('[data-product-features]');
    if (!featuresSection) return;

    const sliderContainer = featuresSection.querySelector('[data-product-features-carousel]');
    const prevButton = featuresSection.querySelector('[data-carousel-previous]');
    const nextButton = featuresSection.querySelector('[data-carousel-next]');

    let featuresSlider;

    function initSlider() {
      if (window.innerWidth < 750) {
        if (featuresSlider) {
          featuresSlider.destroy();
          featuresSlider = null;
        }
        sliderContainer.classList.add('is-mobile');
        return;
      } else {
        sliderContainer.classList.remove('is-mobile');
      }

      if (featuresSlider) return;

      function updateClasses(s) {
        if (!s || !s.track) return;
        const slides = s.slides;
        const activeSlide = s.track.details.rel;

        // Remove is-active from all slides
        for (let i = 0; i < slides.length; i++) {
          slides[i].classList.remove('is-active');
        }

        // Add is-active to the current slide
        if (slides[activeSlide]) {
          slides[activeSlide].classList.add('is-active');
        }
      }

      featuresSlider = new KeenSlider(sliderContainer, {
        loop: true,
        slides: {
          perView: 3,
          spacing: 32,
        },
        created: updateClasses,
        slideChanged: updateClasses,
      });

      prevButton.addEventListener('click', () => featuresSlider.prev());
      nextButton.addEventListener('click', () => featuresSlider.next());
    }

    initSlider();

    window.addEventListener('resize', initSlider);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    const sliderContainer = document.querySelector('.c-product-image-carousel__slides');
    const thumbnailContainer = document.querySelector('.c-product-image-carousel__dots');
    let slider; // Declarar slider en un scope más alto

    if (sliderContainer && thumbnailContainer) {
      const thumbnails = thumbnailContainer.querySelectorAll('.c-product-carousel-dot');

      slider = new KeenSlider(sliderContainer, {
        loop: false,
        slideChanged(s) {
          updateThumbnails(s.track.details.rel);
        },
        created(s) {
          updateThumbnails(s.track.details.rel);
        },
      });

      function updateThumbnails(idx) {
        thumbnails.forEach((thumbnail, i) => {
          if (i === idx) {
            thumbnail.classList.add('is-active');
          } else {
            thumbnail.classList.remove('is-active');
          }
        });
      }

      thumbnails.forEach((thumbnail, idx) => {
        thumbnail.addEventListener('click', () => {
          slider.moveToIdx(idx);
        });
      });
    }

    // Read more functionality
    const readMoreButton = document.querySelector('[data-read-more-link]');
    const readLessButton = document.querySelector('[data-read-less-link]');
    const shortDescription = document.querySelector('[data-short-description]');
    const readMoreContent = document.querySelector('[data-read-more-content]');

    if (readMoreButton) {
      readMoreButton.addEventListener('click', () => {
        if (shortDescription) shortDescription.style.display = 'none';
        if (readMoreContent) readMoreContent.style.display = 'block';
        readMoreButton.style.display = 'none';
      });
    }

    if (readLessButton) {
      readLessButton.addEventListener('click', () => {
        if (readMoreContent) readMoreContent.style.display = 'none';
        if (shortDescription) shortDescription.style.display = 'block';
        if (readMoreButton) readMoreButton.style.display = 'inline-block';
      });
    }

    // Variant selection functionality - movido fuera del bloque if para tener acceso a slider
    const variantDataElement = document.querySelector('[data-variant-selector-data]');
    if (variantDataElement) {
      const variants = JSON.parse(variantDataElement.innerHTML);
      const swatchButtons = document.querySelectorAll('[data-swatch-object]');
      const priceElement = document.querySelector('[data-product-money]');
      const compareAtPriceElement = document.querySelector('[data-product-compare-money]');
      const colorLabel = document.querySelector('[data-swatches-color-label]');
      const variantDropdown = document.querySelector('.o-variant-selector__dropdown');

      swatchButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const variantId = parseInt(button.dataset.variantId, 10);
          const selectedVariant = variants.find((v) => v.id === variantId);

          if (selectedVariant) {
            // Update prices
            const formatMoney = (price) => {
              let shop_symbol = document.getElementById('shop-money-format').value;
              shop_symbol = shop_symbol.trim();
              if (
                shop_symbol.substring(shop_symbol.length - 1) !== '}' &&
                shop_symbol.substring(shop_symbol.length - 1).length > 0
              ) {
                shop_symbol = shop_symbol.substring(shop_symbol.length - 1);
              } else {
                shop_symbol = shop_symbol.substring(0, 1);
              }
              return shop_symbol + (price / 100).toFixed(2).replace('.', ',');
            };
            priceElement.textContent = formatMoney(selectedVariant.price);
            if (compareAtPriceElement) {
              if (selectedVariant.compare_at_price > selectedVariant.price) {
                compareAtPriceElement.textContent = formatMoney(selectedVariant.compare_at_price);
                compareAtPriceElement.style.display = 'inline';
              } else {
                compareAtPriceElement.style.display = 'none';
              }
            }

            // Update color label
            if (colorLabel) {
              colorLabel.textContent = selectedVariant.option1;
            }

            // Update swatches active state
            swatchButtons.forEach((btn) => btn.classList.remove('is-selected'));
            button.classList.add('is-selected');

            // Update dropdown
            if (variantDropdown) {
              variantDropdown.value = selectedVariant.id;
            }

            // Update image slider - ahora tiene acceso a la variable slider
            if (selectedVariant.featured_image && slider) {
              const imageId = selectedVariant.featured_image.id;
              const imageSlide = document.querySelector(`.c-product-image-carousel__slide[data-image-id='${imageId}']`);
              if (imageSlide) {
                const slideIndex = parseInt(imageSlide.dataset.index, 10);
                slider.moveToIdx(slideIndex);
              }
            }
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-results"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const resultsSection = document.querySelector('[data-product-results]');
    if (!resultsSection) return;

    const imageContainers = resultsSection.querySelectorAll('[data-before-after-image-container]');
    const tabs = resultsSection.querySelectorAll('[data-results-tab]');
    const descriptions = resultsSection.querySelectorAll('[data-results-description]');
    const accordions = resultsSection.querySelectorAll('[data-accordion-slide]');

    function updateSlider(container) {
      const slider = container.querySelector('[data-image-slider-range]');
      const divisor = container.querySelector('[data-image-slider-divisor]');
      const handle = container.querySelector('[data-image-slider-handle]');
      if (slider && divisor && handle) {
        const value = slider.value;
        divisor.style.width = `${value}%`;
        handle.style.left = `${value}%`;
      }
    }

    // Before-After Slider Logic
    imageContainers.forEach((container) => {
      const slider = container.querySelector('[data-image-slider-range]');
      if (slider) {
        slider.addEventListener('input', () => updateSlider(container));
        updateSlider(container); // Initial update
      }
    });

    // Tabs & Accordion Sync Logic
    function syncState(targetIndex) {
      // Deactivate all
      tabs.forEach((t) => t.classList.remove('is-active'));
      descriptions.forEach((d) => d.classList.remove('is-active'));
      imageContainers.forEach((c) => c.classList.remove('is-active'));
      accordions.forEach((a) => {
        a.classList.remove('is-active');
        a.removeAttribute('open');
      });

      // Activate target elements
      const activeTab = resultsSection.querySelector(`[data-results-tab][data-results-index="${targetIndex}"]`);
      const activeDesc = resultsSection.querySelector(
        `[data-results-description][data-results-index="${targetIndex}"]`
      );
      const activeImage = resultsSection.querySelector(
        `[data-before-after-image-container][data-results-index="${targetIndex}"]`
      );
      const activeAccordion = resultsSection.querySelector(
        `[data-accordion-slide][data-results-index="${targetIndex}"]`
      );

      if (activeTab) activeTab.classList.add('is-active');
      if (activeDesc) activeDesc.classList.add('is-active');
      if (activeImage) {
        activeImage.classList.add('is-active');
        updateSlider(activeImage); // Update slider on activation
      }
      if (activeAccordion) {
        activeAccordion.classList.add('is-active');
        activeAccordion.setAttribute('open', '');
      }
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        syncState(tab.dataset.resultsIndex);
      });
    });

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          const targetIndex = accordion.dataset.resultsIndex;
          const isAlreadyOpen = accordion.hasAttribute('open');

          if (isAlreadyOpen) {
            accordion.removeAttribute('open');
          } else {
            syncState(targetIndex);
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
